import homeOld from '@/components/home/home-old/home-old.vue';
import { DAILY_PAGES } from '@/components/pages/page-daily-markets-details/daily-pages.constants';
import env from '@/env';
import log from '@/logger';
import store from '@/store';
import accountRoutes from './account';
import dashboardRoutes from './dashboard';
import staticPages from './static';
import supportRoutes from './support';

const trends = () => import(/* webpackChunkName: "trends" */ '@/components/home/trends/trends.vue');
const pageMarkets = () =>
  import(/* webpackChunkName: "page-markets" */ '@/components/pages/page-markets/page-markets.vue');
const pageStoryDetail = () =>
  import(
    /* webpackChunkName: "page-story-detail" */ '@/components/pages/page-story-detail/page-story-detail.vue'
  );
const pageSearch = () =>
  import(/* webpackChunkName: "page-search" */ '@/components/pages/page-search/page-search.vue');
const pageWatchlist = () =>
  import(
    /* webpackChunkName: "page-watchlist" */ '@/components/pages/page-watchlist/page-watchlist.vue'
  );
const pagePrivacyPolicy = () =>
  import(
    /* webpackChunkName: "page-privacy-policy" */ '@/components/pages/page-privacy-policy/page-privacy-policy.vue'
  );
const pageTermsAndConditions = () =>
  import(
    /* webpackChunkName: "page-terms-and-conditions" */ '@/components/pages/page-terms-and-conditions/page-terms-and-conditions.vue'
  );
const pagePlatformAnnouncements = () =>
  import(
    /* webpackChunkName: "page-platform-announcements" */ '@/components/pages/page-platform-announcements/page-platform-announcements.vue'
  );
const pageDebug = () =>
  import(/* webpackChunkName: "page-debug" */ '@/components/pages/debug/debug.vue');
const pageSitemap = () =>
  import(/* webpackChunkName: "page-sitemap" */ '@/components/pages/page-sitemap/page-sitemap.vue');
const pageResearch = () =>
  import(
    /* webpackChunkName: "page-research" */ '@/components/pages/page-research/page-research.vue'
  );
const pageLeaderboards = () =>
  import(
    /* webpackChunkName: "page-leaderboards" */ '@/components/pages/page-leaderboards/page-leaderboards.vue'
  );
const pageNotFound = () =>
  import(
    /* webpackChunkName: "page-not-found" */ '@/components/pages/page-not-found/page-not-found.vue'
  );
const pageStaticPreview = () =>
  import(
    /* webpackChunkName: "page-static-preview" */ '@/components/pages/page-static-preview/page-static-preview.vue'
  );
const pageStoryPreview = () =>
  import(
    /* webpackChunkName: "page-story-preview" */ '@/components/pages/page-story-preview/page-story-preview.vue'
  );
const pageDailyMarketsDetails = () =>
  import(
    /* webpackChunkName: "page-daily-markets-details" */ '@/components/pages/page-daily-markets-details/page-daily-markets-details.vue'
  );
const pageAccessibilityStatement = () =>
  import(
    /* webpackChunkName: "page-accessibility-statement" */ '@/components/pages/page-accessibility-statement/page-accessibility-statement.vue'
  );
const pageResponsibleTrading = () =>
  import(
    /* webpackChunkName: "page-responsible-trading" */ '@/components/pages/page-responsible-trading/page-responsible-trading.vue'
  );
const pageMidterms = () => import('@/components/pages/page-midterms/page-midterms.vue');
const pageEarlyVoter = () => import('@/components/pages/page-early-voter/page-early-voter.vue');
const pageMarketDetailSushi = () =>
  import(
    /* webpackChunkName: "page-market-detail-sushi" */ '@/components/pages/page-market-detail-sushi/page-market-detail-sushi.vue'
  );
const pageUserStatus = () =>
  import(
    /* webpackChunkName: "page-user-status" */ '@/components/pages/page-user-status/page-user-status.vue'
  );
const pageNewsStories = () =>
  import(
    /* webpackChunkName: "page-news-stories" */ '@/components/pages/page-news-stories/page-news-stories.vue'
  );
const pageNewsArchiveStories = () =>
  import(
    /* webpackChunkName: "page-news-archive-stories" */ '@/components/pages/page-news-archive-stories/page-news-archive-stories.vue'
  );
const pageLearnStories = () =>
  import(
    /* webpackChunkName: "page-learn-stories" */ '@/components/pages/page-learn-stories/page-learn-stories.vue'
  );

const routes = [
  ...accountRoutes,
  ...supportRoutes,
  ...dashboardRoutes,
  ...staticPages,
  {
    path: '/',
    component: homeOld,
    name: 'home',
    beforeEnter: () => {
      store.dispatch('browse/setMarketsPageInitialLoadDone', false);
    },
  },
  {
    path: '/trends',
    component: trends,
    name: 'trends',
    meta: {
      requiresAuth: true,
      appContentFullWidth: true,
    },
  },
  {
    path: '/research',
    component: pageResearch,
    name: 'research',
  },
  {
    path: '/privacy-policy',
    component: pagePrivacyPolicy,
    name: 'privacy-policy',
  },
  {
    path: '/accessibility-statement',
    name: 'accessibility-statement',
    component: pageAccessibilityStatement,
  },
  {
    path: '/terms-and-conditions',
    component: pageTermsAndConditions,
    name: 'terms-and-conditions',
  },
  {
    path: '/responsible-trading',
    component: pageResponsibleTrading,
    name: 'responsible-trading',
  },
  {
    path: '/9cc2d867-e840-4fea-899f-9e9e2da8385c',
    component: pageMidterms,
    name: 'midterms-guid',
    meta: { noindex: true },
  },
  {
    path: '/27b5c9ae-e92f-46c4-9653-47ee7b340b36',
    component: pageEarlyVoter,
    name: 'presidential-elections-guid',
    meta: { noindex: true },
  },
  {
    path: '/platform-announcements',
    component: pagePlatformAnnouncements,
    name: 'platform-announcements',
  },
  {
    path: '/markets/search',
    name: 'market-search',
    component: pageSearch,
  },
  {
    path: '/markets/watchlist',
    name: 'market-watchlist',
    component: pageWatchlist,
    beforeEnter: (to) => {
      // browse.selectedOrder etc i shared by watchlist and markets page
      log.info('[WATCHLIST] Before enter setup');
      if (to.query.sortParameter) {
        store.dispatch('browse/setTimespanFromQuery', { parameter: to.query.sortParameter });
      } else {
        store.dispatch('browse/setTimespanFromQuery', { parameter: 'ALL' });
      }
      if (to.query.sort) {
        store.dispatch('browse/setOrderFromQuery', to.query.sort);
      } else {
        store.dispatch('browse/setOrderFromQuery', 'traded');
      }
    },
  },
  {
    path: '/markets/detail/:marketId/:marketUrl?',
    name: 'market-details',
    component: pageMarketDetailSushi,
    meta: {
      appContentFullWidth: true,
    },
    props: (route) => ({
      marketId: parseInt(route.params.marketId, 10),
      showRules: !!route.params.showRules,
      prerendered: route.query.prerendered,
    }),
  },
  {
    path: '/markets/:headerId?/:headerUrl?',
    name: 'market-list',
    component: pageMarkets,
    beforeEnter: (to, from) => {
      log.info('[MARKETS] Before enter setup');
      const cachedHeaderId = store.state.browse.marketListCachedHeaderId;
      const targetHeaderId = parseInt(to.params.headerId, 10) || 0;
      const returningWithValidCache =
        from.name === 'market-details' && cachedHeaderId === targetHeaderId;
      if (
        !returningWithValidCache &&
        from.name !== 'market-list' &&
        from.name !== 'payment-success' &&
        from.name !== 'payment-fail'
      ) {
        store.dispatch('browse/setMarketsPageInitialLoadDone', false);
      }
      if (to.query.filterIds) {
        to.query.filterIds.split(',').forEach((i) => {
          const filterId = parseInt(i, 10);
          log.info(`[MARKETS] filterId passed: ${filterId}`);
          if (filterId) store.dispatch('browse/addFilter', filterId);
        });
      }
      if (to.query.sortParameter) {
        store.dispatch('browse/setTimespanFromQuery', {
          parameter: to.query.sortParameter,
          dateFrom: to.query.dateFrom,
          dateTo: to.query.dateTo,
        });
      }
      if (to.query.sort) {
        store.dispatch('browse/setOrderFromQuery', to.query.sort);
      }
    },
    props: (route) => ({
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
      page: Math.max(1, parseInt(route.query.page, 10) || 1),
    }),
  },
  {
    path: '/stories/detail/:storyId/:storyUrl?',
    name: 'story-details',
    component: pageStoryDetail,
    props: (route) => ({
      storyId: parseInt(route.params.storyId, 10),
    }),
  },
  {
    path: '/payment/success',
    component: pageMarkets,
    name: 'payment-success',
    props: (route) => ({
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
      notificationText: 'Bitcoin Deposit Received',
      notificationLevel: 'success',
    }),
  },
  {
    path: '/payment/fail',
    component: pageMarkets,
    name: 'payment-fail',
    props: (route) => ({
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
    }),
  },
  {
    path: '/static-page-preview',
    component: pageStaticPreview,
    name: 'static-page-preview',
    beforeEnter: (to) => {
      if (!to.query.previewId) {
        return { name: 'home' };
      }
      return true;
    },
    props: (route) => ({
      previewId: route.query.previewId,
    }),
  },
  {
    path: '/story-full-preview',
    component: pageStoryPreview,
    name: 'story-full-preview',
    beforeEnter: (to) => {
      if (!to.query.previewId) {
        return { name: 'home' };
      }
      return true;
    },
    props: (route) => ({
      previewId: route.query.previewId,
    }),
  },
  {
    path: DAILY_PAGES.MONDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.MONDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.MONDAY.pageId,
    }),
  },
  {
    path: DAILY_PAGES.TUESDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.TUESDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.TUESDAY.pageId,
    }),
  },
  {
    path: DAILY_PAGES.WEDNESDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.WEDNESDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.WEDNESDAY.pageId,
    }),
  },
  {
    path: DAILY_PAGES.THURSDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.THURSDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.THURSDAY.pageId,
    }),
  },
  {
    path: '/sitemap',
    component: pageSitemap,
    name: 'sitemap',
  },
  {
    path: '/user-status',
    component: pageUserStatus,
    name: 'user-status',
  },
  {
    path: '/news',
    component: pageNewsStories,
    name: 'news-stories',
  },
  {
    path: '/news/archive',
    component: pageNewsArchiveStories,
    name: 'news-archive-stories',
  },
  {
    path: '/learn',
    component: pageLearnStories,
    name: 'learn-stories',
  },
  {
    path: '/:pathMatch(.*)*',
    component: pageNotFound,
    name: 'not-found',
  },
];

if (env.NODE_ENV !== 'production') {
  routes.push({
    path: '/debug',
    component: pageDebug,
    name: 'debug',
  });
}

if (env.LEADERBOARDS_ENABLED) {
  routes.push({
    path: '/leaderboards',
    component: pageLeaderboards,
    name: 'leaderboards',
    beforeEnter: (to) => {
      log.info('[LEADERBOARDS] Before enter setup');
      if (typeof to.query.leaderboardId !== 'undefined') {
        log.info(`[LEADERBOARDS] settings leaderboardId: ${to.query.leaderboardId}`);
        store.dispatch(
          'leaderboards/setSelectedLeaderboardId',
          parseInt(to.query.leaderboardId, 10),
        );
      }
      if (to.query.dateRange) {
        log.info(`[LEADERBOARDS] settings dateRange: ${to.query.dateRange}`);
        store.dispatch('leaderboards/setLeaderboardsDateRange', parseInt(to.query.dateRange, 10));
      }
    },
  });
}

if (env.ELECTION_PAGES_PUBLIC_ENABLED) {
  routes.push(
    { path: '/Midterms', component: pageMidterms, name: 'midterms' },
    { path: '/EarlyVoter', component: pageEarlyVoter, name: 'early-voter' },
  );
}

export default routes;
